export const DownMultiFillIcon = () => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="23" height="51" viewBox="0 0 23 51" fill="none">
            <path fillRule="evenodd" clipRule="evenodd" d="M13.2711 16.25L22.5087 0.25H0.687744L9.92535 16.25H0.674561L9.82698 32.1025H0.687744L11.5982 51L22.5087 32.1025H13.1728L22.3252 16.25H13.2711Z" fill="#0095DA" />
        </svg>
    )
}